module.exports = __webpack_public_path__ + "media/images/clearcash-shield-1b65dc1ce980dd227675c11357a609e6.png";